import { InspectorMaterialTab } from "@/components/inspector/tab/MaterialTab";
import { LayerDto, MaterialDto } from "@/types/data-types";
import React, { useEffect, useState } from "react";

export const TabName = {
  Material: "Material",
} as const;
export type TabNameType = keyof typeof TabName;

interface InspectorTabsProps {
  layerInfo: LayerDto;
  currentMaterial: MaterialDto;
  setCurrentMaterial: React.Dispatch<React.SetStateAction<MaterialDto>>;
}

export const InspectorTabs = ({
  layerInfo,
  currentMaterial,
  setCurrentMaterial,
}: InspectorTabsProps) => {
  const [inspectorTab, setInspectorTab] = useState<TabNameType | null>(
    TabName.Material,
  );
  useEffect(() => {
    setInspectorTab(TabName.Material);
  }, [layerInfo.path]);

  const toggleTab = (tab: TabNameType) => {
    setInspectorTab((prevTab) => (prevTab === tab ? null : tab));
  };

  return (
    <>
      <div className="flex p-1">
        <div className="w-full h-px bg-[var(--gray50-alpha50)]" />
      </div>
      <InspectorMaterialTab
        open={inspectorTab === TabName.Material}
        onClick={() => toggleTab(TabName.Material)}
        currentMaterial={currentMaterial}
        setCurrentMaterial={setCurrentMaterial}
      />
    </>
  );
};
